import { NavigateFunction } from "react-router-dom";
import { SearchResponse } from "../../../../components/BrieChatMenu/GPTConvoTypes";
import { getDefaultStore } from "jotai";
import { queryAtomFamily } from "../../../../components/PageView/PageViewTable/SharedToolbar/SharedToolbar";

export function searchCommand({
  message,
  setQuery,
  navigate,
}: {
  message: SearchResponse;
  setQuery: any;
  navigate: NavigateFunction;
}) {
  if (setQuery) {
    return setQuery((prev: any) => {
      if (!prev) return prev;

      return {
        ...prev,
        ...(message?.Query || {}),
      };
    });
  }

  if (message.URL !== window.location.href) {
    let url = `/clouds/${message.TenantID}/workspaces/${message.WorkspaceID}/pages/${message.PageID}/views/${message.ViewID}`;

    if (!setQuery) {
      url += `?q=${encodeURIComponent(JSON.stringify(message.Query))}`;
    }

    // User is already on the correct page.
    // If so, we want to update the query state on the page in case it was changed (and the URL wasn't)
    if (url === window.location.pathname + window.location.search) {
      return updateViewQuery(message);
    }

    navigate(url);
  } else {
    updateViewQuery(message);
  }
}

function updateViewQuery(message: SearchResponse) {
  const store = getDefaultStore();
  const viewQuery = store.get(queryAtomFamily(message?.ViewID));

  if (viewQuery) {
    store.set(queryAtomFamily(message?.ViewID), {
      ...viewQuery,
      ...(message?.Query || {}),
    });
  }
}
